/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Forgotten_Discard_HintInputs */

const en_us2_workout_live_forgotten_discard_hint = /** @type {(inputs: Workout_Live_Forgotten_Discard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sets stay in your history, but the workout doesn't count and your plan doesn't move on.`)
};

const pt_br2_workout_live_forgotten_discard_hint = /** @type {(inputs: Workout_Live_Forgotten_Discard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As séries ficam no histórico, mas o treino não conta e o plano não avança.`)
};

const es_419_workout_live_forgotten_discard_hint = /** @type {(inputs: Workout_Live_Forgotten_Discard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las series quedan en tu historial, pero el entrenamiento no cuenta y tu plan no avanza.`)
};

const pt_pt2_workout_live_forgotten_discard_hint = /** @type {(inputs: Workout_Live_Forgotten_Discard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As séries ficam no histórico, mas o treino não conta e o plano não avança.`)
};

const fr_fr2_workout_live_forgotten_discard_hint = /** @type {(inputs: Workout_Live_Forgotten_Discard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les séries restent dans ton historique, mais la séance ne compte pas et ton programme n'avance pas.`)
};

const de_de2_workout_live_forgotten_discard_hint = /** @type {(inputs: Workout_Live_Forgotten_Discard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sätze bleiben in deinem Verlauf, aber das Training zählt nicht und dein Plan geht nicht weiter.`)
};

const it_it2_workout_live_forgotten_discard_hint = /** @type {(inputs: Workout_Live_Forgotten_Discard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le serie restano nello storico, ma l'allenamento non conta e la scheda non avanza.`)
};

/**
* | output |
* | --- |
* | "The sets stay in your history, but the workout doesn't count and your plan doesn't move on." |
*
* @param {Workout_Live_Forgotten_Discard_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_discard_hint = /** @type {((inputs?: Workout_Live_Forgotten_Discard_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_Discard_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_discard_hint(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_discard_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_discard_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_discard_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_discard_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_discard_hint(inputs)
	return en_us2_workout_live_forgotten_discard_hint(inputs)
});
export { workout_live_forgotten_discard_hint as "workout-live.forgotten_discard_hint" }